/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React from 'react';
import PageHero from '../containers/Pages/PageHero';
import AboutPage from '../containers/Pages/AboutPage';
import HomeFooter from '../containers/Home/HomeFooter';

const About = () => (
  <div>
    <PageHero
      meta={['Vol. 04 — The Label', 'Independent · Est. 2014']}
      eyebrow="About Mastered Trax"
      title="Una casa"
      italic="para la música."
      lede="Somos un sello discográfico independiente que desarrolla artistas con oficio y paciencia — cruzando géneros, idiomas y geografías desde 2014."
    />
    <AboutPage />
    <HomeFooter />
  </div>
);

export default About;
